/*
  Thanh tab lọc review (All Reviews / With Photos / 5 Stars…) cho trang sản phẩm.

  VÌ SAO TỰ DỰNG THAY VÌ DÙNG BỘ LỌC CỦA APP

  Judge.me có sẵn bộ lọc theo sao: mỗi hàng biểu đồ là một nút. Nhưng đo ngày
  13/08/2026 trên cả dev lẫn production, request lọc trả về 200 kèm
  `total_count: 0` và HTML rỗng — dữ liệu lọc không tồn tại phía họ. Bấm vào là
  mất sạch danh sách, "See all reviews" cũng không khôi phục được. Vì vậy các
  hàng biểu đồ đã bị vô hiệu hoá (xem assets/judgeme-custom.css).

  Cách làm ở đây khác hẳn: KHÔNG gọi bộ lọc của họ. Lấy TOÀN BỘ review về một
  lần qua endpoint phân trang (cái này chạy tốt — chính app dùng nó để sang
  trang), rồi lọc và sắp xếp ngay trong trình duyệt.

  Hệ quả kèm theo: tự phân trang và tự sắp xếp luôn, nên phân trang + ô sắp xếp
  của app bị ẩn đi — nếu để lại, chúng sẽ vẽ đè danh sách theo trạng thái riêng
  của app và xoá mất kết quả lọc.

  LƯU Ý VỀ CON SỐ

  Header của widget ghi 13 review nhưng endpoint chỉ trả 10: ba cái chênh là
  review chỉ chấm sao, không có nội dung — app tính vào điểm trung bình nhưng
  không dựng thẻ. Số trên tab lấy theo danh sách THẬT SỰ hiển thị được, để bấm
  vào tab nào cũng ra đúng số đó.
*/
(function () {
  var API = 'https://cdn.judge.me/reviews/reviews_for_widget';
  var PAGE_SIZE = 5;
  var MAX_FETCH = 500;
  /* Chặn trên cho cả nhóm. Mỗi sản phẩm đã bị kẹp ở MAX_FETCH, nhưng nhóm 5 sản
     phẩm nhiều review vẫn có thể dựng vài nghìn node vào DOM một lúc. */
  var MAX_GROUP = 800;
  /*
    Review dưới mức này KHÔNG hiển thị trên trang sản phẩm — chốt 05/10/2026.

    Lọc ngay sau khi lấy dữ liệu, trước khi dựng bất cứ thứ gì, nên tab, điểm
    trung bình, dòng "Based on N reviews", biểu đồ và badge dưới tên sản phẩm
    đều tính trên cùng một tập đã lọc. Đã thử bản chỉ ẩn thẻ mà giữ nguyên số:
    biểu đồ vẫn ghi "1 ★ 1" trong khi danh sách không có thẻ nào — bị hỏi ngay.

    Tab và hàng biểu đồ của các mức bị loại VẪN hiện, với số 0 — "2 Stars (0)",
    "1 Star (0)" — để thang điểm trông đủ 5 mức. Đã thử bỏ hẳn, bị yêu cầu
    hiện lại.

    Review chỉ chấm sao mà không đọc được điểm (rating = 0) thì giữ.
    Đặt về 1 là tắt tính năng. Đổi số ở đây thì đổi cả luật CSS đi kèm ở cuối
    judgeme-custom.css.
  */
  var MIN_STAR = 3;

  var state = null;

  function widget() {
    return document.querySelector('.jdgm-review-widget');
  }

  function shopDomain() {
    return (window.Shopify && window.Shopify.shop) || '';
  }

  /* ---------- Lấy dữ liệu ---------- */

  function apiUrl(productId, page, perPage) {
    var u = new URL(API);
    u.searchParams.set('url', shopDomain());
    u.searchParams.set('shop_domain', shopDomain());
    u.searchParams.set('platform', 'shopify');
    u.searchParams.set('product_id', productId);
    u.searchParams.set('page', page);
    u.searchParams.set('per_page', perPage);
    return u.toString();
  }

  function parseReviews(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return [].slice.call(doc.querySelectorAll('.jdgm-rev'));
  }

  /* Judge.me chỉ trả tối đa ~28 review mỗi lần dù xin per_page=100 (đo 30/10/2026:
     sp 59 review, xin 100 → nhận 28, trang 2 lệch). Xin 20/lần thì đủ và không trùng
     (20 + 20 + 19). Bản cũ xin 100 nên sp hơn 28 review bị hụt — badge trang chi tiết
     ra 54 trong khi đúng là 85. */
  var PER_PAGE = 20;

  function fetchAll(productId) {
    return fetch(apiUrl(productId, 1, PER_PAGE))
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var nodes = parseReviews(data.html || '');
        var total = Math.min(data.total_count || nodes.length, MAX_FETCH);
        if (nodes.length >= total) return nodes;

        /* Hơn PER_PAGE review thì gọi tiếp các trang sau. */
        var pages = [];
        for (var page = 2; (page - 1) * PER_PAGE < total; page++) pages.push(page);

        return Promise.all(
          pages.map(function (page) {
            return fetch(apiUrl(productId, page, PER_PAGE))
              .then(function (r) {
                return r.json();
              })
              .then(function (d) {
                return parseReviews(d.html || '');
              })
              .catch(function () {
                return [];
              });
          })
        ).then(function (rest) {
          return nodes.concat.apply(nodes, rest);
        });
      });
  }

  /* ---------- Gộp review theo nhóm sản phẩm ---------- */

  /*
    Judge.me có "Product groups" nhưng ở gói trả phí. Vì thanh tab này vốn đã tự
    gọi API và tự dựng danh sách, gộp thêm sản phẩm chỉ là gọi thêm vài lần rồi
    trộn kết quả.

    Danh sách product ID anh em do snippets/judgeme-groups.liquid đặt vào
    window.CL_JDGM_GROUP_IDS — khai báo bằng handle, Liquid đổi sang ID.

    KHÔNG gộp phần tóm tắt phía trên (điểm trung bình, biểu đồ số sao): phần đó
    Judge.me dựng ở server, script này không dựng lại. Nên số review trong tab
    "All Reviews" sẽ lớn hơn con số "Based on N reviews" bên trên. Lệch có chủ ý,
    không phải lỗi.
  */
  function siblingIds() {
    var ids = window.CL_JDGM_GROUP_IDS;
    if (!Array.isArray(ids)) return [];
    return ids.filter(function (id) {
      return id !== null && id !== undefined && id !== '';
    });
  }

  /* Đường dẫn sản phẩm đang xem, để phân biệt review nhà với review mượn.
     Cắt theo /products/<handle> nên không vướng query, hash hay tiền tố ngôn ngữ. */
  function ownPath() {
    var m = window.location.pathname.match(/\/products\/[^\/?#]+/);
    return m ? m[0] : '';
  }

  /*
    Gắn nhãn cho review mượn.

    Mỗi thẻ .jdgm-rev từ API đều mang sẵn data-product-title và data-product-url
    của sản phẩm gốc, nên không cần theo dõi review nào đến từ lần gọi nào —
    đọc thẳng trên node là đủ, và vẫn đúng nếu Judge.me đổi thứ tự trả về.
  */
  function groupProducts() {
    var list = window.CL_JDGM_GROUP_PRODUCTS;
    return Array.isArray(list) ? list : [];
  }

  /* Bỏ query/hash rồi so — data-product-url của app là đường dẫn trần. */
  function samePath(a, b) {
    if (!a || !b) return false;
    return a.split('?')[0].split('#')[0] === b.split('?')[0].split('#')[0];
  }

  function findProduct(url) {
    var list = groupProducts();
    for (var i = 0; i < list.length; i++) {
      if (samePath(list[i].url, url)) return list[i];
    }
    return null;
  }

  /*
    Thẻ sản phẩm cạnh review mượn.

    Thay cho dòng chữ "Review for: <tên>" trước đây. Cùng mục đích — cho biết
    review thuộc món nào — nhưng đọc được ngay bằng mắt (ảnh + giá) thay vì phải
    đọc hết một dòng chữ dài, và mở thêm đường bán hàng.

    NÚT BẤM: nhãn phải nói đúng việc nó làm, và KHÔNG được trùng với thao tác bấm
    vào tên sản phẩm (tên đã là liên kết sang trang đó rồi).

      - `personalize > 0`  -> "Personalize"   (sang trang để nhập tuỳ chỉnh)
      - `variantCount > 1` -> "Choose options" (sang trang để chọn biến thể)
      - `available false`  -> "Sold out"       (vô hiệu)
      - còn lại            -> "Add to cart"    (thêm thẳng vào giỏ)

    VÌ SAO KHÔNG PHẢI LÚC NÀO CŨNG "ADD TO CART":

    Sản phẩm có ô Customily mà add thẳng là tạo đơn KHÔNG kèm dữ liệu cá nhân hoá
    — xưởng nhận về không biết in tên gì. Đây không phải lỗi hiển thị mà là đơn
    hỏng. Theme đã có hẳn snippets/customily-buy-guard.liquid chỉ để chặn đúng
    chuyện này trên trang sản phẩm: đo được nút mua của theme bấm được ở 1,51s
    trong khi Customily mới sẵn sàng ở 3,09s, và ~1,6s ở giữa đủ để khách tạo một
    đơn hỏng. Đặt Add to cart lên thẻ review là mở lại đúng lỗ đó, ở chỗ guard
    không với tới.

    Tương tự với nhiều biến thể: đoán hộ cỡ/màu là giao nhầm hàng.

    Ở printfamily gần như mọi sản phẩm đều có Customily nên nhánh add-to-cart
    hiếm khi chạy — vẫn giữ vì nhóm sau này có thể gồm sản phẩm không cá nhân hoá.
  */
  function buildProductCard(product) {
    var card = document.createElement('aside');
    card.className = 'cl-jdgm-prod';

    /* Cột 1 — ảnh. */
    var media = document.createElement('a');
    media.className = 'cl-jdgm-prod__media';
    media.href = product.url;
    if (product.image) {
      var img = document.createElement('img');
      img.src = product.image;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 96;
      img.height = 96;
      media.appendChild(img);
    }
    card.appendChild(media);

    /* Cột 2 — tên trên, biến thể dưới (căn hai đầu theo chiều dọc). */
    var main = document.createElement('div');
    main.className = 'cl-jdgm-prod__main';

    var title = document.createElement('a');
    title.className = 'cl-jdgm-prod__title';
    title.href = product.url;
    title.textContent = product.title || 'View product';
    main.appendChild(title);

    var variant = document.createElement('p');
    variant.className = 'cl-jdgm-prod__variant';
    /* "Default Title" là tên biến thể mặc định của Shopify khi sản phẩm chỉ có một
       biến thể — in ra chỉ tổ rác mắt. Vẫn giữ thẻ rỗng để nó chiếm chỗ, nhờ vậy
       nút bên cột phải luôn thẳng hàng dù sản phẩm có hay không có biến thể. */
    variant.textContent =
      product.variantCount > 1 && product.variantTitle && product.variantTitle !== 'Default Title'
        ? product.variantTitle
        : '';
    main.appendChild(variant);
    card.appendChild(main);

    /* Cột 3 — giá trên, nút dưới, cả hai căn phải. */
    var side = document.createElement('div');
    side.className = 'cl-jdgm-prod__side';

    var price = document.createElement('p');
    price.className = 'cl-jdgm-prod__price';
    var now = document.createElement('span');
    now.className = 'cl-jdgm-prod__now';
    now.textContent = product.price || '';
    price.appendChild(now);
    /* Chỉ gạch giá cũ khi thực sự đang giảm — compare_at bằng hoặc thấp hơn giá
       bán là dữ liệu rác, hiện ra thành "giảm 0đ". */
    if (false && product.onSale > 0 && product.compareAt) { /* 24/10: chỉ 1 giá */
      var was = document.createElement('s');
      was.className = 'cl-jdgm-prod__was';
      was.textContent = product.compareAt;
      price.appendChild(was);
    }
    side.appendChild(price);

    var canQuickAdd =
      product.available !== false &&
      !product.personalize &&
      product.variantCount === 1 &&
      product.variantId;

    var cta;
    if (canQuickAdd) {
      cta = document.createElement('button');
      cta.type = 'button';
      cta.addEventListener('click', function () {
        cta.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: product.variantId, quantity: 1 }] }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            /* Hỏng thì trả khách về trang sản phẩm, đừng để nút chết câm. */
            window.location.href = product.url;
          });
      });
    } else {
      cta = document.createElement('a');
      cta.href = product.url;
      if (product.available === false) cta.setAttribute('aria-disabled', 'true');
    }
    cta.className = 'cl-jdgm-prod__cta';

    /* Icon giỏ CHỈ đi cùng hành động thêm vào giỏ; nút chỉ dẫn sang trang khác mà
       đeo icon giỏ là hứa sai việc nó làm. Nhánh cá nhân hoá dùng icon bút cho
       khớp nghĩa, và để hai kiểu nút trông cân nhau. */
    var text;
    if (canQuickAdd) {
      cta.appendChild(cartIcon());
      text = 'Add to cart';
    } else if (product.available === false) {
      text = 'Sold out';
    } else if (product.personalize) {
      cta.appendChild(pencilIcon());
      text = 'Personalize';
    } else {
      text = 'Choose options';
    }
    var label = document.createElement('span');
    label.textContent = text;
    cta.appendChild(label);

    side.appendChild(cta);
    card.appendChild(side);

    return card;
  }

  function pencilIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '15');
    svg.setAttribute('height', '15');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.8');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    var p1 = document.createElementNS(ns, 'path');
    p1.setAttribute('d', 'M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17z');
    svg.appendChild(p1);
    return svg;
  }

  function cartIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.8');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M6 7h13l-1.4 8.4a2 2 0 0 1-2 1.6H9.4a2 2 0 0 1-2-1.6L5.6 4.6A1 1 0 0 0 4.6 4H3');
    svg.appendChild(path);
    [9.5, 16].forEach(function (cx) {
      var c = document.createElementNS(ns, 'circle');
      c.setAttribute('cx', String(cx));
      c.setAttribute('cy', '20');
      c.setAttribute('r', '1.2');
      c.setAttribute('fill', 'currentColor');
      c.setAttribute('stroke', 'none');
      svg.appendChild(c);
    });
    return svg;
  }

  /*
    Cột phải của thẻ review: NGÀY ở trên, khung sản phẩm ngay dưới nó.

    Ngày vốn nằm trong .jdgm-rev__header của app, mà header thì trải hết bề ngang
    và cao ~75px (avatar + tên + Verified + sao). Để nguyên thì khung sản phẩm bắt
    đầu tận dưới đáy header — cách ngày một khoảng trống bằng cả khối ấy.

    Nên bê thẻ ngày sang cột phải, xếp chung một cột dọc với khung. Không sao chép
    mà DI CHUYỂN đúng node gốc: describe() và judgeme-fix.js đều tra
    `.jdgm-rev__timestamp` trong phạm vi thẻ review, nhân bản ra là chúng bắt phải
    bản sai và ngày sẽ không được định dạng.
  */
  function sideColumn(node, card) {
    var side = document.createElement('div');
    side.className = 'cl-jdgm-side';

    /* 16/10/2026: ngày KHÔNG bê sang đây nữa — bố cục mới đặt ngày ở dòng 2 đầu thẻ
       (cạnh "Verified Purchase"), xem judgeme-redesign.css. */
    side.appendChild(card);
    return side;
  }

  /*
    Gắn dấu cho review mượn.

    Mỗi thẻ .jdgm-rev từ API đều mang sẵn data-product-title và data-product-url
    của sản phẩm gốc, nên không cần theo dõi review nào đến từ lần gọi nào —
    đọc thẳng trên node là đủ, và vẫn đúng nếu Judge.me đổi thứ tự trả về.

    Có dữ liệu sản phẩm thì dựng thẻ; không có (nhóm khai bằng handle mà sản phẩm
    đã bị xoá, hoặc Judge.me trả review của sản phẩm ngoài nhóm) thì rơi về dòng
    chữ như cũ — vẫn phải nói rõ review này của món khác, không được im lặng.
  */
  function tagBorrowed(node, own) {
    var url = node.getAttribute('data-product-url') || '';
    var title = node.getAttribute('data-product-title') || '';
    if (!url || !own || samePath(url, own)) return false;

    node.dataset.clBorrowed = '1';
    if (node.querySelector('.cl-jdgm-prod, .cl-jdgm-from')) return true;

    var product = findProduct(url);
    if (product) {
      node.appendChild(sideColumn(node, buildProductCard(product)));
      return true;
    }

    var link = document.createElement('a');
    link.className = 'cl-jdgm-from';
    link.href = url;
    link.textContent = 'Review for: ' + (title || 'another product');
    var content = node.querySelector('.jdgm-rev__content') || node;
    content.insertBefore(link, content.firstChild);
    return true;
  }

  function dedupe(nodes) {
    var seen = {};
    var out = [];
    nodes.forEach(function (node) {
      var id = node.getAttribute('data-review-id') || '';
      if (id) {
        if (seen[id]) return;
        seen[id] = 1;
      }
      out.push(node);
    });
    return out;
  }

  /*
    Lấy review cho cả nhóm: sản phẩm đang xem + TOÀN BỘ sản phẩm anh em, luôn luôn.

    KHÔNG có ngưỡng, không "đủ thì dừng". Bản trước dừng sớm khi đã gom đủ 20
    review, và nó tạo ra một vách đứng vô lý: sản phẩm 19 review nhà thì mượn
    thêm rồi hiện ~87, sản phẩm 21 review nhà thì thôi hẳn và hiện 21. Chênh hai
    review mà kết quả lệch gấp bốn lần, hai sản phẩm cùng danh mục nằm cạnh nhau
    trông như hai hệ thống khác nhau.

    Giờ mọi sản phẩm trong danh mục lấy đúng cùng một nhóm. Khác biệt duy nhất
    còn lại là mỗi sản phẩm không mượn được của chính nó — điều không tránh được.

    Số lượng do Liquid quyết (`max_siblings` trong judgeme-groups.liquid), ở đây
    dùng hết những gì được đưa. Một con số, một chỗ khai, không có phép cắt nào
    ở tầng này để hai bên lệch nhau.

    Chi phí CỐ ĐỊNH: 1 + số anh em. Đo 21/08/2026 với 6 anh em: 7 request cho
    mọi sản phẩm, kể cả danh mục cạn review — bản cũ tốn tới 13 cho ca đó.
  */
  function fetchGroup(productId) {
    var own = ownPath();
    var ids = [productId].concat(siblingIds());

    return Promise.all(
      ids.map(function (id) {
        /* Một sản phẩm anh em hỏng thì bỏ qua nó, không kéo cả nhóm chết theo. */
        return fetchAll(id).catch(function () { return []; });
      })
    ).then(function (batches) {
      var all = dedupe([].concat.apply([], batches));
      all.forEach(function (node) { tagBorrowed(node, own); });
      return all.slice(0, MAX_GROUP);
    });
  }

  /* ---------- Chuẩn hoá markup ---------- */

  /*
    HTML lấy từ API là bản PHẲNG: header chứa thẳng .jdgm-rev__rating,
    .jdgm-rev__timestamp, .jdgm-rev__icon, .jdgm-rev__author… trong khi bản app
    dựng sẵn trên trang lại bọc chúng trong .jdgm-row-rating / .jdgm-row-profile
    / .jdgm-rev__author-wrapper. Hai template khác nhau.

    Toàn bộ CSS lưới của thẻ review (assets/judgeme-custom.css) bám vào các thẻ
    bọc đó — chèn thẳng bản phẳng vào là avatar, tên, sao, ngày rơi tự do mỗi
    thứ một dòng.

    Nên dựng lại đúng bộ khung ấy. Chỉ bọc, không đổi nội dung, và bỏ qua nếu
    thẻ bọc đã có sẵn (phòng khi Judge.me đổi template về cùng một dạng).
  */
  /*
    Tái dùng thẻ bọc nếu có sẵn, chỉ tạo mới khi thiếu.

    Bản API có sẵn một `.jdgm-rev__author-wrapper` nhưng bên trong CHỈ có nhãn
    Verified, còn tên người viết lại nằm ngoài. Tạo thẻ mới vô điều kiện là
    thành hai thẻ cùng tên, nhãn Verified hiện hai lần.
  */
  function box(header, selector, className, tag) {
    var el = header.querySelector(selector);
    if (!el) el = document.createElement(tag || 'div');
    el.className = className;
    return el;
  }

  function normalize(node) {
    var header = node.querySelector('.jdgm-rev__header');
    if (!header || header.dataset.clNormalized) return node;

    var rating = header.querySelector('.jdgm-rev__rating');
    var stamp = header.querySelector('.jdgm-rev__timestamp');
    var icon = header.querySelector('.jdgm-rev__icon');
    var author = header.querySelector('.jdgm-rev__author');
    var badge = header.querySelector('.jdgm-rev__buyer-badge-wrapper');
    var extra = header.querySelector('.jdgm-row-extra');

    if (!rating && !author) return node;

    var authorWrapper = box(header, '.jdgm-rev__author-wrapper', 'jdgm-rev__author-wrapper', 'span');
    /* Tên phải đứng trước nhãn Verified, nên chèn vào đầu chứ không nối đuôi. */
    if (author) authorWrapper.insertBefore(author, authorWrapper.firstChild);
    if (badge && badge.parentNode !== authorWrapper) authorWrapper.appendChild(badge);

    var profile = box(header, '.jdgm-row-profile', 'jdgm-row-profile');
    if (icon) profile.appendChild(icon);
    profile.appendChild(authorWrapper);

    var ratingRow = box(header, '.jdgm-row-rating', 'jdgm-row-rating');
    if (rating) ratingRow.appendChild(rating);
    if (stamp) ratingRow.appendChild(stamp);

    /* appendChild với node đang nằm trong DOM là DI CHUYỂN, không nhân bản —
       nên thứ tự cuối cùng đúng bằng thứ tự gọi ở đây. */
    header.appendChild(ratingRow);
    header.appendChild(profile);
    if (extra) header.appendChild(extra);

    /*
      App in sẵn chữ cái đầu dưới dạng text ngay trong ô avatar (" J "), mà chữ
      cái của mình lại vẽ bằng CSS ::before — để cả hai thì chữ hiện hai lần,
      một trong vòng tròn một rơi xuống dưới. Dọn text đi, giữ phần CSS.
    */
    if (icon && icon.textContent.trim()) icon.textContent = '';

    /*
      Ngày đăng: app trả về thẻ <time> RỖNG kèm class `jdgm-spinner`, rồi JS
      riêng của nó mới định dạng ngày và gỡ class. Mình chèn thẳng HTML nên đoạn
      đó không chạy — kết quả là một vòng tròn quay mãi ở góc phải mỗi thẻ.

      Tự định dạng từ thuộc tính `datetime` có sẵn. Dùng MM/DD/YYYY cho khớp
      đúng cách app đang hiển thị ở những thẻ do nó tự dựng.
    */
    fixStamp(stamp);

    /*
      Người viết không phải khách đã mua thì app vẫn để lại thẻ bọc nhãn nhưng
      RỖNG. Thẻ rỗng vẫn kéo theo dấu tích xanh mà CSS vẽ ở ::before — thành ra
      một cái tích trơ trọi không kèm chữ nào.
    */
    if (badge && !badge.querySelector('.jdgm-rev__buyer-badge')) badge.remove();

    /*
      Ảnh khách gửi: app để link ở class `jdgm--loading` rồi mới gán src bằng JS
      riêng của nó. Mình chèn thẳng HTML nên đoạn JS đó không chạy, ảnh đứng
      mãi ở ô xám. Tự gán src từ chính đường dẫn có sẵn trên link, và hạ bề
      ngang xuống 240px — bản gốc là 1024px, dùng cho ô 88px thì quá phí.
    */
    node.querySelectorAll('.jdgm-rev__pic-link').forEach(function (link) {
      link.classList.remove('jdgm--loading');

      var source = link.getAttribute('data-mfp-src') || link.getAttribute('href') || '';
      if (!source) return;
      var thumb = source.replace(/([?&]width=)\d+/, '$1240');

      var img = link.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        img.className = 'jdgm-rev__pic-img';
        img.setAttribute('loading', 'lazy');
        img.setAttribute('alt', link.getAttribute('aria-label') || '');
        link.appendChild(img);
      }
      if (!img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src') || thumb);
    });

    header.dataset.clNormalized = '1';
    return node;
  }

  /* ---------- Bóc dữ liệu từng review ---------- */

  /*
    Định dạng ngày cho một thẻ review.

    App trả về thẻ <time> RỖNG kèm class `jdgm-spinner`, rồi JS riêng của nó mới
    điền ngày và gỡ class. Mình chèn thẳng HTML nên đoạn đó không chạy — kết quả
    là một vòng tròn quay mãi ở góc mỗi thẻ.

    PHẢI GỌI LẠI ĐƯỢC NHIỀU LẦN, không chỉ một lượt lúc dựng: JS của app quét lại
    mỗi khi danh sách đổi và GẮN LẠI spinner + xoá chữ. Đo 21/08/2026: bấm "Show
    more" một cái là cả 10 thẻ đang hiện — kể cả 5 thẻ trước đó đã đúng ngày —
    quay về rỗng và quay tròn.

    Dùng MM/DD/YYYY cho khớp đúng cách app hiển thị ở những thẻ do nó tự dựng.
  */
  function fixStamp(stamp) {
    if (!stamp) return;

    var raw = stamp.getAttribute('datetime') || stamp.getAttribute('data-content') || '';
    var when = new Date(raw.replace(' ', 'T').replace(' UTC', 'Z'));
    if (isNaN(when.getTime())) return;

    var pad = function (n) {
      return String(n).length < 2 ? '0' + n : String(n);
    };
    /*
      Ghi vào thuộc tính RIÊNG rồi để CSS vẽ ra bằng ::after, thay vì sửa
      textContent và gỡ class `jdgm-spinner`.

      Vì sao không sửa trực tiếp: JS của app quét lại mỗi khi danh sách đổi, gắn
      lại spinner và xoá sạch chữ. Bản trước tôi chống bằng MutationObserver —
      thành ra hai observer giằng co nhau vô hạn, đo 21/08/2026: main thread treo
      cứng, CDP không gọi nổi hàm nào.

      Thuộc tính `data-cl-date` app không biết tới nên không đụng vào. App muốn
      gắn lại spinner bao nhiêu lần cũng được, ngày vẫn hiện đúng, và không có
      vòng lặp nào vì mình không phản ứng lại nữa.
    */
    stamp.setAttribute('data-cl-date', pad(when.getMonth() + 1) + '/' + pad(when.getDate()) + '/' + when.getFullYear());
  }

  /* Chữa mọi thẻ ngày đang hiện trong danh sách của mình. */
  function fixStampsIn(root) {
    if (!root) return;
    [].slice.call(root.querySelectorAll('.jdgm-rev__timestamp')).forEach(fixStamp);
  }

  function describe(node) {
    normalize(node);

    var ratingEl = node.querySelector('.jdgm-rev__rating');
    var stampEl = node.querySelector('.jdgm-rev__timestamp');
    var stamp = stampEl && stampEl.getAttribute('data-content');

    return {
      node: node,
      rating: ratingEl ? parseInt(ratingEl.getAttribute('data-score'), 10) || 0 : 0,
      hasPhoto: !!node.querySelector('.jdgm-rev__pic-img, .jdgm-rev__pics img'),
      /* Chuỗi dạng "2024-05-23 17:48:38 UTC" — Safari không đọc được nếu để
         nguyên khoảng trắng, phải đổi sang định dạng ISO. */
      time: stamp ? Date.parse(stamp.replace(' ', 'T').replace(' UTC', 'Z')) || 0 : 0,
      /* 24/10/2026 (doc mục 6.14 "sort Most helpful"): lượt vote của Judge.me + độ dài nội dung. */
      helpful: (parseInt(node.getAttribute('data-thumb-up-count'), 10) || 0) - (parseInt(node.getAttribute('data-thumb-down-count'), 10) || 0),
      length: ((node.querySelector('.jdgm-rev__body') || {}).textContent || '').trim().length,
    };
  }

  /* ---------- Dựng khối review ---------- */

  /*
    16/10/2026 — làm lại theo ảnh mẫu user gửi:
      - trên cùng 2 tab "Item Reviews" / "Store Reviews";
      - cột trái: khung nền be "Reviews for this item" — điểm, số review, % từng mức sao,
        nút Write a Review (node gốc của app, bê sang để giữ nguyên trình xử lý của nó);
      - cột phải: "Reviews with Images" (dải ảnh trượt + mũi tên ‹ ›, bấm mở ảnh lớn),
        "Top reviews" + Sort, hàng nút lọc "All Reviews (27) · 5 Star (26) …", danh sách,
        phân trang.

    Dải ảnh lấy từ CHÍNH tập review đang xem. Trước đây dùng khối reviews_grid_widget của app,
    mà khối đó trả ảnh của CẢ STORE — trang thảm chùi chân hiện toàn ảnh ornament.

    Tab Store Reviews = toàn bộ review của shop, cùng nguồn với /pages/reviews
    (assets/pf-all-reviews.js). Chỉ tải khi khách bấm vào tab. Cùng luật MIN_STAR.

    Mỗi tab giữ trạng thái riêng (nút lọc, sort, trang) trong state.sources.
  */
  var STORE_API = 'https://cdn.judge.me/widgets/reviews_grid_widget_data';
  var STORE_PAGE = 24;

  /*
    23/10/2026 — Judge.me khoá CẢ SHOP (429/503, keycdn) khi bị gọi nhiều: tab Store hiện 0.0 và
    "could not be loaded", dải review trang chủ biến mất. Mọi lần gọi lưới review của shop đi qua
    jmGet(), dùng chung giữa judgeme-tabs.js, pf-all-reviews.js, pf-reviews-carousel.js:
    - mỗi trang API nhớ 6 tiếng trong localStorage (chỉ giữ trường cần dùng);
    - lỗi 429/5xx/mạng thì cả 3 file ngưng gọi 10 phút (khoá 'pf-jm-cooldown');
    - đang lỗi mà có bản cũ (tới 30 ngày) thì dùng bản cũ.
    Không đọc/ghi được localStorage (ẩn danh…) thì vẫn gọi mạng như trước.
  */
  var JM_TTL = 6 * 60 * 60 * 1000;
  var JM_STALE = 30 * 24 * 60 * 60 * 1000;
  var JM_COOL = 10 * 60 * 1000;
  var JM_COOL_KEY = 'pf-jm-cooldown';

  function jmRead(key) {
    try { return JSON.parse(window.localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  function jmWrite(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function jmSlim(data) {
    var reviews = (data && Array.isArray(data.reviews) ? data.reviews : []).map(function (r) {
      return {
        uuid: r.uuid,
        rating: r.rating,
        title: r.title,
        body: r.body,
        verified_buyer: r.verified_buyer,
        is_anonymous_reviewer: r.is_anonymous_reviewer,
        created_at: r.created_at,
        reviewer_name: r.reviewer_name,
        product_url: r.product_url,
        product_title: r.product_title,
        product_in_store: r.product_in_store,
        pictures_urls: (Array.isArray(r.pictures_urls) ? r.pictures_urls : []).map(function (p) {
          return { small: p.small, compact: p.compact, mobile: p.mobile, original: p.original, huge: p.huge };
        }),
      };
    });
    return { total_pages: data && data.total_pages, reviews: reviews };
  }

  function jmGet(url) {
    var key = 'pf-jm:' + String(url).split('?')[1];
    var hit = jmRead(key);
    var now = Date.now();
    if (hit && hit.d && now - hit.t < JM_TTL) return Promise.resolve(hit.d);
    var stale = hit && hit.d && now - hit.t < JM_STALE ? hit.d : null;
    var fail = function (err) {
      if (stale) return stale;
      throw err;
    };
    if ((Number(jmRead(JM_COOL_KEY)) || 0) > now) return Promise.resolve().then(function () { return fail(new Error('Judge.me cooldown')); });
    var cool = function () { jmWrite(JM_COOL_KEY, Date.now() + JM_COOL); };
    return fetch(url)
      .then(
        function (r) {
          if (!r.ok) {
            if (r.status === 429 || r.status >= 500) cool();
            throw new Error('Judge.me ' + r.status);
          }
          return r.json();
        },
        function (err) {
          /* 429 của keycdn không có header CORS nên fetch báo lỗi mạng thay vì trả status. */
          cool();
          throw err;
        }
      )
      .then(function (data) {
        var d = jmSlim(data);
        jmWrite(key, { t: Date.now(), d: d });
        return d;
      })
      .catch(fail);
  }

  var MAX_PHOTOS = 30;

  function tabDefs() {
    var defs = [{ key: 'all', label: 'All Reviews', match: function () { return true; } }];
    /* 24/10/2026 (doc mục 6.14 "lọc có ảnh"). Review mượn ở tab Item bị ẩn ảnh nên không tính. */
    defs.push({ key: 'photos', label: 'With Photos', match: hasVisiblePhoto });
    [5, 4, 3, 2, 1].forEach(function (star) {
      defs.push({
        key: 'star-' + star,
        label: star + ' Star',
        match: function (r) { return r.rating === star; },
      });
    });
    return defs;
  }

  function current() {
    return state.sources[state.source];
  }

  function hasVisiblePhoto(r) {
    if (!r.hasPhoto) return false;
    return !(state.source === 'item' && r.node && r.node.hasAttribute && r.node.hasAttribute('data-cl-borrowed'));
  }

  function make(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function arrowSvg(d) {
    return '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true"><path d="' + d + '" stroke="currentColor" stroke-width="1.600" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }
  var LEFT = 'M10 3.500 5.500 8l4.500 4.500';
  var RIGHT = 'm6 3.500 4.500 4.500L6 12.500';

  /* Số sao tô đầy, cùng ngưỡng 0.3 / 0.7 với blocks/review.liquid (xem syncBadge). */
  function filledStars(avg) {
    var decimal = avg % 1;
    return Math.floor(avg) + (decimal > 0.7 ? 1 : 0);
  }

  function stats(reviews) {
    var freq = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    var sum = 0;
    var rated = 0;
    reviews.forEach(function (r) {
      if (r.rating >= 1 && r.rating <= 5) {
        freq[r.rating]++;
        sum += r.rating;
        rated++;
      }
    });
    return { freq: freq, rated: rated, avg: rated ? sum / rated : 0, total: reviews.length };
  }

  /* ---------- Tab Item / Store ---------- */

  function buildSourceTabs() {
    var nav = make('div', 'cl-rv-source');
    nav.setAttribute('role', 'tablist');
    [
      ['item', 'Item Reviews'],
      ['store', 'Store Reviews'],
    ].forEach(function (pair) {
      var b = make('button', 'cl-rv-source__tab', pair[1]);
      b.type = 'button';
      b.dataset.clSource = pair[0];
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', pair[0] === 'item' ? 'true' : 'false');
      b.addEventListener('click', function () {
        switchSource(pair[0]);
      });
      /* Rê chuột / chạm vào tab Store là bắt đầu tải luôn, trước cả cú bấm. */
      if (pair[0] === 'store') {
        var warm = function () {
          var src = state && state.sources.store;
          if (src && !src.loaded && !src.loading) loadStore();
        };
        b.addEventListener('pointerenter', warm);
        b.addEventListener('touchstart', warm, { passive: true });
        b.addEventListener('focus', warm);
      }
      nav.appendChild(b);
    });
    /* Gạch chân trượt giữa 2 tab (CSS transition left/width 0.3s) — theo macorner.co. */
    nav.appendChild(make('span', 'cl-rv-source__indicator'));
    /* Lúc dựng, widget có thể đang ẩn (đo ra 0) — đo lại khi khung đổi kích thước. */
    if (window.ResizeObserver) new ResizeObserver(function () { moveIndicator(nav); }).observe(nav);
    return nav;
  }

  function moveIndicator(nav) {
    var active = nav.querySelector('.cl-rv-source__tab[aria-selected="true"]');
    var bar = nav.querySelector('.cl-rv-source__indicator');
    if (!active || !bar) return;
    bar.style.left = active.offsetLeft + 'px';
    bar.style.width = active.offsetWidth + 'px';
  }

  function switchSource(key) {
    if (state.source === key) return;
    state.source = key;
    state.sourceTabs.querySelectorAll('.cl-rv-source__tab').forEach(function (b) {
      b.setAttribute('aria-selected', b.dataset.clSource === key ? 'true' : 'false');
    });
    moveIndicator(state.sourceTabs);
    var src = current();
    if (key === 'store' && !src.loaded && !src.loading) loadStore();
    renderAll();
  }

  /* ---------- Khung tóm tắt (cột trái) ---------- */

  function buildSummary(header) {
    var box = make('div', 'cl-rv-summary');
    box.appendChild(make('p', 'cl-rv-summary__title'));

    var scoreRow = make('div', 'cl-rv-summary__score-row');
    scoreRow.appendChild(make('span', 'cl-rv-summary__score'));
    var right = make('div', 'cl-rv-summary__meta');
    var stars = make('span', 'cl-rv-summary__stars');
    stars.setAttribute('aria-hidden', 'true');
    right.appendChild(stars);
    right.appendChild(make('span', 'cl-rv-summary__count'));
    scoreRow.appendChild(right);
    box.appendChild(scoreRow);

    var bars = make('div', 'cl-rv-summary__bars');
    [5, 4, 3, 2, 1].forEach(function (star) {
      var row = make('div', 'cl-rv-summary__bar-row');
      row.dataset.star = String(star);
      /* 24/10/2026: bấm 1 thanh = lọc đúng mức sao đó (như nút "5 Star"). */
      row.setAttribute('role', 'button');
      row.tabIndex = 0;
      var pick = function () {
        if (current().loading) return;
        select('star-' + star);
        /* Trên mobile danh sách nằm dưới biểu đồ: cuộn tới hàng nút lọc nếu nó đang khuất.
           Trang cuộn bằng .page-wrapper nên scrollIntoView không ăn. */
        var r = state.pills && state.pills.getBoundingClientRect();
        /* Desktop cuộn bằng .page-wrapper; mobile/WebKit có lúc cuộn cả document (đo 24/10). */
        var pw = document.querySelector('.page-wrapper');
        var scroller = pw && /(auto|scroll)/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight ? pw : document.scrollingElement;
        if (r && scroller && (r.top < 80 || r.top > window.innerHeight - 120)) {
          /* 'smooth' trên .page-wrapper không nhúc nhích (đo WebKit + Chromium 24/10) → nhảy thẳng. */
          scroller.scrollTo({ top: scroller.scrollTop + r.top - 120, behavior: 'instant' });
        }
      };
      row.addEventListener('click', pick);
      row.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      row.appendChild(make('span', 'cl-rv-summary__bar-label', star + ' Star'));
      var track = make('span', 'cl-rv-summary__track');
      track.appendChild(make('span', 'cl-rv-summary__fill'));
      row.appendChild(track);
      row.appendChild(make('span', 'cl-rv-summary__pct'));
      bars.appendChild(row);
    });
    box.appendChild(bars);

    /*
      Nút "Write a Review" là nút RIÊNG, bấm thì kích hoạt nút gốc của app.
      Không bê node gốc sang được: JS của app vẽ lại phần header sau đó và kéo nó về
      chỗ cũ (đo 16/10/2026 trên dev). Nút gốc vẫn nằm trong header — thứ bị giấu bằng CSS.
    */
    var write = make('button', 'cl-rv-summary__write', 'Write a Review');
    write.type = 'button';
    write.addEventListener('click', function () {
      var original = document.querySelector('.jdgm-review-widget .jdgm-write-rev-link');
      if (original) original.click();
    });
    box.appendChild(write);

    header.insertBefore(box, header.firstChild);
    return box;
  }

  function renderSummary() {
    var src = current();
    var box = state.summary;
    /* Đang tải: tính như chưa có review (điểm --, thanh 0%) dù danh sách đã hiện trang đầu. */
    var s = stats(src.loading ? [] : src.reviews);
    box.dataset.source = state.source;

    box.querySelector('.cl-rv-summary__title').textContent = src.title;
    box.querySelector('.cl-rv-summary__score').textContent = src.loading ? '--' : s.rated ? fmtScore(s.avg) : '0.0';

    var stars = box.querySelector('.cl-rv-summary__stars');
    var filled = s.rated ? filledStars(s.avg) : 0;
    stars.textContent = '';
    for (var i = 1; i <= 5; i++) stars.appendChild(make('span', i <= filled ? 'is-on' : 'is-off', '★'));

    var count = box.querySelector('.cl-rv-summary__count');
    count.textContent = src.loading ? 'Loading…' : s.total + (s.total === 1 ? ' Review' : ' Reviews');

    [5, 4, 3, 2, 1].forEach(function (star) {
      var row = box.querySelector('.cl-rv-summary__bar-row[data-star="' + star + '"]');
      var pct = s.rated ? Math.round((s.freq[star] / s.rated) * 100) : 0;
      row.querySelector('.cl-rv-summary__fill').style.width = pct + '%';
      row.querySelector('.cl-rv-summary__pct').textContent = pct + '%';
      row.setAttribute('aria-label', pct + '% of reviews have ' + star + ' star' + (star === 1 ? '' : 's'));
    });
  }

  /* ---------- Reviews with Images ---------- */

  function buildPhotos() {
    var section = make('section', 'cl-rv-photos');
    section.hidden = true;

    var head = make('div', 'cl-rv-photos__head');
    head.appendChild(make('h3', 'cl-rv-photos__title', 'Reviews with Images'));
    var nav = make('div', 'cl-rv-photos__nav');
    var prev = make('button', 'cl-rv-photos__arrow');
    prev.type = 'button';
    prev.setAttribute('aria-label', 'Previous photos');
    prev.innerHTML = arrowSvg(LEFT);
    var next = make('button', 'cl-rv-photos__arrow');
    next.type = 'button';
    next.setAttribute('aria-label', 'Next photos');
    next.innerHTML = arrowSvg(RIGHT);
    nav.appendChild(prev);
    nav.appendChild(next);
    head.appendChild(nav);
    section.appendChild(head);

    var track = make('div', 'cl-rv-photos__track');
    section.appendChild(track);

    function step(dir) {
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { updateArrows(); }, { passive: true });
    /* Lúc dựng, widget có thể còn đang ẩn (app/judgeme-defer chưa thả) nên đo ra bề rộng 0 và
       mũi tên bị tắt nhầm — đo lại mỗi khi dải ảnh đổi kích thước. */
    if (window.ResizeObserver) new ResizeObserver(function () { updateArrows(); }).observe(track);

    state_photo = { section: section, track: track, prev: prev, next: next };
    return section;
  }

  /* Biến riêng cho dải ảnh vì buildPhotos() chạy trước khi state được tạo. */
  var state_photo = null;

  function updateArrows() {
    var p = state_photo;
    if (!p) return;
    var max = p.track.scrollWidth - p.track.clientWidth;
    p.prev.disabled = p.track.scrollLeft <= 2;
    p.next.disabled = p.track.scrollLeft >= max - 2;
    p.section.classList.toggle('is-static', max <= 2);
  }

  /* Ảnh từ thẻ review: href của link là bản 1024px; ô trong dải dùng bản 480px. */
  function photoItems(reviews) {
    var items = [];
    sortedBy('recent', reviews).some(function (r) {
      /* Review mượn của sp khác KHÔNG lên dải ảnh — khách tưởng ảnh của sp đang xem (sếp góp ý 16/10). */
      if (r.node.dataset.clBorrowed) return false;
      r.node.querySelectorAll('.jdgm-rev__pic-link').forEach(function (link) {
        if (items.length >= MAX_PHOTOS) return;
        var full = link.getAttribute('data-mfp-src') || link.getAttribute('href') || '';
        /* Bỏ GIF động khỏi dải ảnh (thường là ảnh chụp story/màn hình, nhảy khung liên tục);
           thẻ review bên dưới vẫn giữ. */
        if (!full || /\.gif(\?|$)/i.test(full)) return;
        items.push({ review: r, full: full, thumb: full.replace(/([?&]width=)\d+/, '$1480') });
      });
      return items.length >= MAX_PHOTOS;
    });
    return items;
  }

  function renderPhotos() {
    var p = state_photo;
    /* 16/10/2026: tab Store Reviews KHÔNG có dải ảnh — theo macorner.co (user gửi ảnh so sánh). */
    var items = state.source === 'store' ? [] : photoItems(current().reviews);
    state.photoItems = items;
    p.track.textContent = '';
    p.section.hidden = !items.length;
    items.forEach(function (item, index) {
      var b = make('button', 'cl-rv-photos__item');
      b.type = 'button';
      b.setAttribute('aria-label', 'Open review photo ' + (index + 1));
      var img = make('img');
      img.src = item.thumb;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 240;
      img.height = 240;
      b.appendChild(img);
      b.addEventListener('click', function () { openLightbox(index); });
      p.track.appendChild(b);
    });
    p.track.scrollLeft = 0;
    updateArrows();
  }

  /* ---------- Xem ảnh lớn ---------- */

  function buildLightbox() {
    var dlg = make('dialog', 'cl-rv-lb');
    dlg.setAttribute('aria-label', 'Review photo');
    dlg.innerHTML =
      '<div class="cl-rv-lb__frame">' +
      '<div class="cl-rv-lb__media"><img class="cl-rv-lb__img" alt="">' +
      '<button type="button" class="cl-rv-lb__arrow cl-rv-lb__arrow--prev" aria-label="Previous photo">' + arrowSvg(LEFT) + '</button>' +
      '<button type="button" class="cl-rv-lb__arrow cl-rv-lb__arrow--next" aria-label="Next photo">' + arrowSvg(RIGHT) + '</button></div>' +
      '<div class="cl-rv-lb__info"></div>' +
      '<button type="button" class="cl-rv-lb__close" aria-label="Close">' +
      '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true"><path d="m3.500 3.500 9 9m0-9-9 9" stroke="currentColor" stroke-width="1.600" stroke-linecap="round"/></svg></button>' +
      '</div>';
    dlg.querySelector('.cl-rv-lb__close').addEventListener('click', function () { dlg.close(); });
    dlg.querySelector('.cl-rv-lb__arrow--prev').addEventListener('click', function () { showPhoto(state.lbIndex - 1); });
    dlg.querySelector('.cl-rv-lb__arrow--next').addEventListener('click', function () { showPhoto(state.lbIndex + 1); });
    /* Bấm ra nền tối (chính thẻ dialog, ngoài khung) thì đóng. */
    dlg.addEventListener('click', function (event) {
      if (event.target === dlg) dlg.close();
    });
    dlg.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') showPhoto(state.lbIndex - 1);
      if (event.key === 'ArrowRight') showPhoto(state.lbIndex + 1);
    });
    document.body.appendChild(dlg);
    state.lightbox = dlg;
    return dlg;
  }

  function textOf(node, selector) {
    var el = node.querySelector(selector);
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function showPhoto(index) {
    var items = state.photoItems || [];
    if (!items.length) return;
    state.lbIndex = (index + items.length) % items.length;
    var item = items[state.lbIndex];
    var dlg = state.lightbox;
    var node = item.review.node;

    dlg.querySelector('.cl-rv-lb__img').src = item.full;
    dlg.querySelectorAll('.cl-rv-lb__arrow').forEach(function (b) { b.hidden = items.length < 2; });

    var info = dlg.querySelector('.cl-rv-lb__info');
    info.textContent = '';
    var stars = make('p', 'cl-rv-lb__stars');
    for (var i = 1; i <= 5; i++) stars.appendChild(make('span', i <= item.review.rating ? 'is-on' : 'is-off', '★'));
    info.appendChild(stars);
    info.appendChild(make('p', 'cl-rv-lb__author', textOf(node, '.jdgm-rev__author')));
    var stamp = node.querySelector('.jdgm-rev__timestamp');
    var date = stamp ? stamp.getAttribute('data-cl-date') || stamp.textContent.trim() : '';
    if (date) info.appendChild(make('p', 'cl-rv-lb__date', date));
    var title = textOf(node, '.jdgm-rev__title');
    if (title) info.appendChild(make('p', 'cl-rv-lb__title', title));
    var body = textOf(node, '.jdgm-rev__body');
    if (body) info.appendChild(make('p', 'cl-rv-lb__body', body));
    var product = node.querySelector('.cl-jdgm-prod__title, .cl-jdgm-from');
    if (product) {
      var link = make('a', 'cl-rv-lb__product', 'Reviewed: ' + (product.textContent || '').replace(/^Review for:\s*/, '').trim());
      link.href = product.getAttribute('href');
      info.appendChild(link);
    }
  }

  function openLightbox(index) {
    var dlg = state.lightbox || buildLightbox();
    showPhoto(index);
    if (!dlg.open) {
      if (dlg.showModal) dlg.showModal();
      else dlg.setAttribute('open', '');
    }
  }

  /* ---------- "Top reviews" + Sort + nút lọc ---------- */

  function buildTop() {
    var top = make('div', 'cl-rv-top');
    top.appendChild(make('h3', 'cl-rv-top__title', 'Top reviews'));

    var sortWrap = make('label', 'cl-jdgm-sort');
    sortWrap.appendChild(make('span', null, 'Sort by:'));
    var sort = make('select', 'cl-jdgm-tabs__sort');
    sort.setAttribute('aria-label', 'Sort reviews');
    [
      ['helpful', 'Most helpful'],
      ['recent', 'Most recent'],
      ['photos', 'With photos first'],
      ['highest', 'Highest rating'],
      ['lowest', 'Lowest rating'],
    ].forEach(function (pair) {
      var option = make('option', null, pair[1]);
      option.value = pair[0];
      sort.appendChild(option);
    });
    sort.addEventListener('change', function () {
      var src = current();
      src.sort = sort.value;
      src.page = 1;
      render();
    });
    sortWrap.appendChild(sort);
    top.appendChild(sortWrap);

    state_sort = sort;
    return top;
  }

  var state_sort = null;

  function renderPills() {
    var src = current();
    var pills = state.pills;
    pills.textContent = '';
    tabDefs().forEach(function (def) {
      var count = src.reviews.filter(def.match).length;
      /* Đang tải: chưa có số đếm thật — hiện nhãn trơn, khoá nút (giống macorner lúc tải). */
      var b = make('button', 'cl-jdgm-tabs__tab', src.loading ? def.label : def.label + ' (' + count + ')');
      b.type = 'button';
      b.dataset.clTab = def.key;
      b.setAttribute('aria-pressed', def.key === src.tab ? 'true' : 'false');
      /* Mức 0 review vẫn bấm được (chị Thủy 20/10: "đừng khoá") — bấm vào thì danh sách trống. */
      if (src.loading) b.disabled = true;
      b.addEventListener('click', function () { select(def.key); });
      pills.appendChild(b);
    });
  }

  function select(key) {
    var src = current();
    src.tab = key;
    src.page = 1;
    state.pills.querySelectorAll('.cl-jdgm-tabs__tab').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.clTab === key ? 'true' : 'false');
    });
    render();
  }

  /* ---------- Vẽ danh sách ---------- */

  function sortedBy(mode, list) {
    var copy = list.slice();
    if (mode === 'highest') {
      copy.sort(function (a, b) { return b.rating - a.rating || b.time - a.time; });
    } else if (mode === 'lowest') {
      copy.sort(function (a, b) { return a.rating - b.rating || b.time - a.time; });
    } else if (mode === 'helpful') {
      /* Nhiều vote hữu ích trước; bằng nhau thì review có ảnh, viết dài hơn, mới hơn. */
      copy.sort(function (a, b) {
        return (b.helpful || 0) - (a.helpful || 0) ||
          (hasVisiblePhoto(b) ? 1 : 0) - (hasVisiblePhoto(a) ? 1 : 0) ||
          (b.length || 0) - (a.length || 0) ||
          b.time - a.time;
      });
    } else if (mode === 'photos') {
      copy.sort(function (a, b) { return (b.hasPhoto ? 1 : 0) - (a.hasPhoto ? 1 : 0) || b.time - a.time; });
    } else {
      copy.sort(function (a, b) { return b.time - a.time; });
    }
    return copy;
  }

  /* Dãy số trang: 1 2 3 … N, luôn có trang đầu, trang cuối và hai bên trang đang xem. */
  function pageNumbers(current, total) {
    var out = [];
    for (var n = 1; n <= total; n++) {
      if (n === 1 || n === total || Math.abs(n - current) <= 1 || (current <= 2 && n <= 3) || (current >= total - 1 && n >= total - 2)) {
        out.push(n);
      } else if (out[out.length - 1] !== 0) {
        out.push(0);
      }
    }
    return out;
  }

  function goToPage(page) {
    current().page = page;
    render();
    /* Trang cuộn bằng .page-wrapper (html/body overflow hidden) — xem ghi chú ở các file
       khác của theme. Chỉ kéo lên khi đầu danh sách đã trôi khỏi màn hình. */
    var top = state.top.getBoundingClientRect().top;
    if (top < 120) {
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper) wrapper.scrollTo({ top: wrapper.scrollTop + top - 160, behavior: 'instant' });
    }
  }

  function buildPager(page, total) {
    var pager = state.more;
    pager.textContent = '';
    pager.hidden = total <= 1;
    if (total <= 1) return;

    function item(label, target, opts) {
      var el = document.createElement(target ? 'button' : 'span');
      el.className = 'cl-jdgm-pager__item' + (opts && opts.className ? ' ' + opts.className : '');
      if (target) {
        el.type = 'button';
        if (opts && opts.aria) el.setAttribute('aria-label', opts.aria);
        if (opts && opts.disabled) el.disabled = true;
        if (target === page && !(opts && opts.arrow)) el.setAttribute('aria-current', 'page');
        el.addEventListener('click', function () {
          if (target !== current().page) goToPage(target);
        });
      }
      if (opts && opts.html) el.innerHTML = label;
      else el.textContent = label;
      pager.appendChild(el);
    }

    item(arrowSvg(LEFT), Math.max(1, page - 1), { html: true, arrow: true, aria: 'Previous page', disabled: page === 1, className: 'cl-jdgm-pager__arrow' });
    pageNumbers(page, total).forEach(function (n) {
      if (n === 0) item('…', 0, { className: 'cl-jdgm-pager__gap' });
      else item(String(n), n, { aria: 'Page ' + n });
    });
    item(arrowSvg(RIGHT), Math.min(total, page + 1), { html: true, arrow: true, aria: 'Next page', disabled: page === total, className: 'cl-jdgm-pager__arrow' });
  }

  function render() {
    var src = current();
    var def = tabDefs().filter(function (d) { return d.key === src.tab; })[0];
    var visible = sortedBy(src.sort, src.reviews.filter(def ? def.match : function () { return true; }));

    /* Phân trang đánh số (5 review mỗi trang). */
    var pages = Math.max(1, Math.ceil(visible.length / PAGE_SIZE));
    src.page = Math.min(Math.max(1, src.page || 1), pages);
    var start = (src.page - 1) * PAGE_SIZE;

    state.list.textContent = '';
    /* CSS dựa vào cờ này: tab Store không có Sort, không có dòng "Reviewed: …" (theo macorner.co). */
    state.top.dataset.source = state.list.dataset.source = state.source;
    visible.slice(start, start + PAGE_SIZE).forEach(function (item) {
      /*
        JS của app tự phân trang bằng thuộc tính `hidden` trên từng thẻ review, theo
        trạng thái riêng của nó (5 thẻ mỗi trang, không biết gì về tab đang chọn).
        Thẻ mượn từ sản phẩm anh em bị nó quét trúng và ẩn sạch — thấy rõ ở sản phẩm
        0 review: với app thì trang 1 rỗng nên nó ẩn tất, kể cả thẻ mình vừa chèn.
        Gỡ ở đây, và chặn lần nữa bằng CSS phòng khi app ẩn lại sau lượt render này.
      */
      item.node.removeAttribute('hidden');
      state.list.appendChild(item.node);
    });
    /* App gắn lại spinner mỗi khi danh sách đổi — chữa lại sau mỗi lượt vẽ. */
    fixStampsIn(state.list);

    /* Đang tải dở (tab Store): chưa biết tổng số trang — chỉ hiện trang đầu, chưa có thanh số trang. */
    buildPager(src.page, src.loading ? 1 : pages);

    /* Đang tải: vòng xoay cam giữa danh sách (CSS vẽ), giống macorner.co. */
    state.empty.classList.toggle('is-loading', !!src.loading && !visible.length);
    state.empty.textContent = src.loading
      ? ''
      : src.failed
        ? 'Reviews could not be loaded. Please try again later.'
        : state.source === 'item' && !src.reviews.length
          ? 'No reviews for this item yet — be the first to share yours.'
          : src.reviews.length
            ? 'No reviews with this rating yet.'
            : 'No reviews yet.';
    state.empty.hidden = visible.length > 0;
    /* Chưa có review nào thì "Top reviews", Sort và hàng nút lọc không có gì để làm. */
    state.top.hidden = state.pills.hidden = !src.loading && !src.reviews.length;
  }

  function renderAll() {
    renderSummary();
    renderPhotos();
    renderPills();
    state_sort.value = current().sort;
    render();
  }

  /* ---------- Review của cả shop (tab Store Reviews) ---------- */

  /* Judge.me trả vài trường đã mã hoá HTML (&amp;) — giải mã trước khi gán textContent. */
  function decodeHtml(value) {
    var area = document.createElement('textarea');
    area.innerHTML = String(value == null ? '' : value);
    return area.value;
  }

  /*
    Dựng thẻ .jdgm-rev "phẳng" giống HTML của reviews_for_widget, để normalize(), describe(),
    và toàn bộ CSS của danh sách dùng chung được cho cả hai tab.
    Dùng DOM API + textContent, không chèn HTML của review.
  */
  function storeNode(review) {
    var node = make('div', 'jdgm-rev');
    node.setAttribute('data-review-id', review.uuid);

    var header = make('div', 'jdgm-rev__header');
    var rating = make('span', 'jdgm-rev__rating');
    var score = Number(review.rating) || 0;
    rating.setAttribute('data-score', String(score));
    rating.setAttribute('aria-label', score + ' star review');
    rating.setAttribute('role', 'img');
    for (var i = 1; i <= 5; i++) rating.appendChild(make('span', 'jdgm-star ' + (i <= score ? 'jdgm--on' : 'jdgm--off')));
    header.appendChild(rating);

    var stamp = make('time', 'jdgm-rev__timestamp');
    stamp.setAttribute('datetime', review.created_at || '');
    stamp.setAttribute('data-content', review.created_at || '');
    header.appendChild(stamp);

    header.appendChild(make('span', 'jdgm-rev__author', decodeHtml(review.reviewer_name) || 'Anonymous'));
    if (review.verified_buyer) {
      var badgeWrap = make('span', 'jdgm-rev__buyer-badge-wrapper');
      badgeWrap.appendChild(make('span', 'jdgm-rev__buyer-badge'));
      header.appendChild(badgeWrap);
    }
    node.appendChild(header);

    var content = make('div', 'jdgm-rev__content');
    var title = decodeHtml(review.title).trim();
    if (title) content.appendChild(make('b', 'jdgm-rev__title', title));
    var body = make('div', 'jdgm-rev__body');
    body.appendChild(make('p', null, decodeHtml(review.body)));
    content.appendChild(body);

    var pics = Array.isArray(review.pictures_urls) ? review.pictures_urls : [];
    if (pics.length) {
      var wrap = make('div', 'jdgm-rev__pics');
      pics.forEach(function (p, index) {
        var full = p.huge || p.original;
        if (!full) return;
        var link = make('a', 'jdgm-rev__pic-link');
        link.href = full;
        link.target = '_blank';
        link.rel = 'nofollow';
        link.setAttribute('data-mfp-src', full);
        link.setAttribute('aria-label', 'Review photo ' + (index + 1));
        wrap.appendChild(link);
      });
      content.appendChild(wrap);
    }
    node.appendChild(content);

    /* Review của sản phẩm (không phải review cửa hàng) thì ghi rõ món nào — cùng dòng
       "Reviewed: …" như review mượn ở tab Item. */
    var url = review.product_url;
    if (url && url !== '/' && review.product_in_store !== false) {
      var side = make('div', 'cl-jdgm-side');
      var prod = make('aside', 'cl-jdgm-prod');
      var main = make('div', 'cl-jdgm-prod__main');
      var link2 = make('a', 'cl-jdgm-prod__title', decodeHtml(review.product_title));
      link2.href = url;
      main.appendChild(link2);
      prod.appendChild(main);
      side.appendChild(prod);
      node.appendChild(side);
    }
    return node;
  }

  function storeUrl(page) {
    var u = new URL(STORE_API);
    u.searchParams.set('page', page);
    u.searchParams.set('show_media_only', 'false');
    u.searchParams.set('per_page', STORE_PAGE);
    u.searchParams.set('review_selection', 'all');
    /* Mới nhất trước: trang API đầu tiên chính là 5 review đầu của danh sách mặc định, nên
       hiện được ngay sau 1 request (~1,2s) thay vì chờ đủ 18 trang (3–9s) — 16/10/2026. */
    u.searchParams.set('display_order', 'newest');
    u.searchParams.set('shop_domain', shopDomain());
    u.searchParams.set('platform', 'shopify');
    return u.toString();
  }

  /* Bản nhớ cũ của tab Store (16–23/10/2026) — giờ không đọc nữa, xoá cho gọn. */
  try {
    window.localStorage.removeItem('pf-store-reviews-v1');
  } catch (e) {}

  function hideStoreTab() {
    var tab = state.sourceTabs && state.sourceTabs.querySelector('[data-cl-source="store"]');
    if (tab) {
      tab.hidden = true;
      tab.style.display = 'none';
    }
    if (state.source === 'store') switchSource('item');
    else if (state.sourceTabs) moveIndicator(state.sourceTabs);
  }

  function loadStore() {
    var src = state.sources.store;
    var seen = {};
    src.loading = true;

    function add(data) {
      (Array.isArray(data.reviews) ? data.reviews : []).forEach(function (review) {
        if (!review || !review.uuid || seen[review.uuid]) return;
        var score = Number(review.rating) || 0;
        if (score && score < MIN_STAR) return;
        seen[review.uuid] = 1;
        src.reviews.push(describe(storeNode(review)));
      });
    }

    /*
      23/10/2026: KHÔNG tải đủ ~18 trang từ Judge.me nữa — họ khoá cả shop (429) nếu gọi nhiều.
      Nguồn chính là bản chụp assets/pf-store-reviews.json (CDN Shopify, không giới hạn; tạo bằng
      ~/LapTrinh/printfamily-judgeme-snapshot/build.py). Thêm đúng 1 lần gọi Judge.me lấy trang
      review mới nhất (nhớ 6 tiếng qua jmGet) để review viết sau bản chụp vẫn hiện.
    */
    function snapshot() {
      var url = window.PF_STORE_REVIEWS_URL;
      if (!url) return Promise.reject(new Error('no snapshot'));
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('snapshot ' + r.status);
        return r.json();
      });
    }

    function settle(p) {
      return p.then(function (v) { return v; }, function () { return null; });
    }

    Promise.all([settle(jmGet(storeUrl(1))), settle(snapshot())]).then(function (got) {
      if (got[0]) add(got[0]);
      if (got[1]) add(got[1]);
      src.loading = false;
      src.loaded = true;
      src.failed = !src.reviews.length;
      /* Judge.me lỗi mà không có gì để hiện — ẩn hẳn tab Store, khỏi hiện "0.0" và câu báo lỗi. */
      if (src.failed) hideStoreTab();
      if (state.source === 'store') renderAll();
    });
  }

  /* ---------- Khởi tạo ---------- */

  /*
    16/10/2026 — dựng khung NGAY ở trạng thái đang tải (điểm "--", thanh % trống, nút lọc mờ,
    vòng xoay), rồi fillItem() điền dữ liệu khi API trả về: thanh % chạy dài ra, danh sách hiện
    dần — theo macorner.co. Trước đây khung chỉ dựng khi đã có dữ liệu, trong lúc chờ khách thấy
    giao diện gốc của app rồi bị thay bất ngờ.
  */
  function buildUI() {
    var host = document.querySelector('.jdgm-rev-widg__reviews');
    var widg = host && host.closest('.jdgm-rev-widg');
    var header = widg && widg.querySelector('.jdgm-rev-widg__header');
    if (!host || !widg || !header) return false;

    var sourceTabs = buildSourceTabs();
    widg.insertBefore(sourceTabs, widg.firstChild);

    var summary = buildSummary(header);

    var photos = buildPhotos();
    var top = buildTop();
    var pills = make('div', 'cl-jdgm-tabs');
    pills.setAttribute('role', 'group');
    pills.setAttribute('aria-label', 'Filter reviews by rating');

    host.parentNode.insertBefore(photos, host);
    host.parentNode.insertBefore(top, host);
    host.parentNode.insertBefore(pills, host);

    var list = make('div', 'cl-jdgm-list');
    var empty = make('p', 'cl-jdgm-empty');
    empty.hidden = true;

    /* Thanh số trang (tên biến `more` giữ từ thời còn là nút "Show more"). */
    var more = make('nav', 'cl-jdgm-pager');
    more.setAttribute('aria-label', 'Review pages');
    more.hidden = true;

    /* Cất các thẻ gốc của app; gọi API hỏng thì teardown() trả lại. */
    var original = document.createDocumentFragment();
    while (host.firstChild) original.appendChild(host.firstChild);
    host.appendChild(list);
    host.appendChild(empty);
    host.appendChild(more);
    host.dataset.clTabsReady = '1';

    /*
      Dọn dấu vết của judgeme-fix.js::hideForeignReviews(). Nó chạy theo nhịp
      400ms nên rất có thể đã kịp kết luận "sản phẩm này 0 review" và dán dòng
      mời viết TRƯỚC khi lượt gọi API của mình trả về. Dòng đó nằm ở
      .jdgm-rev-widg__header, ngoài `host`, nên không bị xoá theo khi mình thay
      nội dung host — phải gỡ tay.

      Thuộc tính `data-cl-no-own-reviews` cũng phải gỡ: CSS dùng nó để giấu điểm
      số, biểu đồ và phân trang.
    */
    var stale = document.querySelector('.cl-jdgm-none');
    if (stale) stale.remove();
    var reviewWidget = document.querySelector('.jdgm-review-widget');
    if (reviewWidget) reviewWidget.removeAttribute('data-cl-no-own-reviews');

    state = {
      source: 'item',
      sources: {
        item: { title: 'Reviews for this item', reviews: [], tab: 'all', sort: 'helpful', page: 1, loaded: false, loading: true },
        store: { title: 'Reviews for this store', reviews: [], tab: 'all', sort: 'recent', page: 1, loaded: false, loading: false },
      },
      list: list,
      more: more,
      empty: empty,
      pills: pills,
      summary: summary,
      top: top,
      sourceTabs: sourceTabs,
      photos: photos,
      host: host,
      original: original,
    };

    /*
      Phân trang và ô sắp xếp của app phải tắt: chúng vẽ đè danh sách theo trạng
      thái riêng của app (5 review mỗi trang, không biết gì về tab đang chọn) và
      xoá mất kết quả lọc. Ẩn bằng thuộc tính trên widget để CSS xử lý, gọn hơn
      là đụng vào từng node. CSS cũng dựa vào cờ này để giấu phần tóm tắt gốc của app.
    */
    var w = widget();
    if (w) w.dataset.clTabs = 'on';

    renderAll();
    return true;
  }

  function fillItem(reviews) {
    var src = state.sources.item;
    src.reviews = reviews;
    src.loading = false;
    src.loaded = true;
    renderAll();
    syncBadge(reviews);
    /* Gỡ lớp che số cũ — xem chú thích ở snippets/judgeme-groups.liquid. Đặt SAU
       syncBadge/pinSummary để khách không kịp thấy giá trị trung gian nào. */
    document.documentElement.classList.add('cl-jdgm-synced');
  }

  /* Gọi API hỏng: gỡ khung mới, trả lại danh sách + giao diện gốc của app. */
  function teardown() {
    if (!state) return;
    [state.sourceTabs, state.summary, state.photos, state.top, state.pills, state.list, state.empty, state.more].forEach(function (node) {
      if (node && node.parentNode) node.parentNode.removeChild(node);
    });
    state.host.appendChild(state.original);
    delete state.host.dataset.clTabsReady;
    state = null;
  }

  /*
    Một chỗ duy nhất quyết định điểm trung bình hiển thị ra sao — badge dưới tên
    sản phẩm và khối tóm tắt widget PHẢI đọc giống hệt nhau.

    Một chữ số thập phân, theo badge của theme (`{{ rating | round: 1 }}` trong
    blocks/review.liquid). Judge.me vốn in hai chữ số (4.79) nhưng đó là chỗ mình
    ghi đè, còn badge thì nằm rải khắp site (kể cả thẻ sản phẩm) nên lấy nó làm
    chuẩn rẻ hơn.

    Quan trọng hơn con số: hai nơi gọi CÙNG hàm này trên CÙNG giá trị avg, nên
    không thể lệch nhau vì khác biểu thức làm tròn — thứ rất dễ xảy ra nếu một
    bên toFixed(1) còn bên kia round: 1 với số như 4.85.
  */
  function fmtScore(avg) {
    return avg.toFixed(1);
  }

  /* ---------- Đồng bộ badge dưới tên sản phẩm ---------- */

  /*
    Badge sao dưới tên sản phẩm (blocks/review.liquid) dựng ở SERVER từ metafield
    `reviews.rating` và `reviews.rating_count` của Shopify. Con số đó KHÔNG liên
    quan gì tới danh sách review bên dưới.

    Đo 21/08/2026 trên deer-heart-doe-buck: metafield ghi 152 review / 4.79 sao,
    trong khi Judge.me trả về ĐÚNG 0 review cho sản phẩm này, và nhóm gộp được 18.
    Quét mẫu 18 sản phẩm thì 12 cái cùng cảnh, con số còn lặp theo cụm (152 ở 4
    sản phẩm, 13 ở 4, 9 ở 3) — metafield bị gán hàng loạt chứ không phải số thật
    của từng sản phẩm.

    Nên viết lại badge theo đúng thứ đang hiển thị bên dưới. Chỉ chạy sau khi
    takeOver() thành công, tức là đã cầm danh sách thật trong tay — không bao giờ
    ghi đè bằng dữ liệu đoán.

    NGƯỠNG LÀM TRÒN SAO chép y nguyên blocks/review.liquid (0.3 / 0.7). Lệch ngưỡng
    là badge do JS vẽ lại lệch nửa sao so với badge Liquid vẽ ở sản phẩm khác.

    PHẠM VI: chỉ badge của sản phẩm đang xem. Thẻ sản phẩm gợi ý cuối trang cũng
    dùng chung class `.rating-wrapper`; sửa trúng chúng là gán nhầm điểm của sản
    phẩm này cho sản phẩm khác. Bám `[data-review-scroll]` (badge "Jump to reviews"
    chỉ có ở sản phẩm đang xem), dự phòng bằng cách loại thẻ nằm trong product card.
  */
  function mainRatingWrapper() {
    var scoped = document.querySelector('.rating-wrapper[data-review-scroll]');
    if (scoped) return scoped;

    var all = [].slice.call(document.querySelectorAll('.rating-wrapper'));
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('product-card, .product-card, .card')) return all[i];
    }
    return null;
  }

  function syncBadge(reviews) {
    if (!reviews.length) return;

    var sum = 0;
    var rated = 0;
    reviews.forEach(function (r) {
      if (r.rating > 0) {
        sum += r.rating;
        rated++;
      }
    });
    if (!rated) return;

    var total = reviews.length;
    var avg = sum / rated;

    /* Giống hệt blocks/review.liquid. */
    var decimal = avg % 1;
    var decimalRating = 0;
    if (decimal >= 0.3 && decimal <= 0.7) decimalRating = 0.5;
    else if (decimal > 0.7) decimalRating = 1;
    var filled = Math.floor(avg) + Math.ceil(decimalRating);

    var wrap = mainRatingWrapper();
    if (wrap) {
      var stars = wrap.querySelector('.rating');
      if (stars) {
        stars.setAttribute('aria-label', 'Rating of this product is ' + fmtScore(avg) + ' out of 5');
        [].slice.call(stars.querySelectorAll('svg.stars')).forEach(function (svg, index) {
          var star = index + 1;
          if (star <= filled) svg.classList.add('filled-star');
          else svg.classList.remove('filled-star');

          var use = svg.querySelector('use');
          if (!use) return;
          /* Nửa sao vẽ bằng gradient `#half` — cùng cách Liquid làm. */
          if (decimalRating === 0.5 && star === filled) use.setAttribute('fill', 'url(#half)');
          else use.removeAttribute('fill');
        });
      }

      var box = wrap.querySelector('.rating-count');
      if (box) {
        /* Thẻ đầu là điểm trung bình (aria-hidden), rồi tới "(N)" và bản cho
           trình đọc màn hình. Bám theo class chứ không theo thứ tự con, trừ ô
           điểm vốn không có class riêng. */
        var score = box.querySelector('span[aria-hidden="true"]:not(.rating-count__total)');
        if (score) score.textContent = fmtScore(avg);

        var totalBox = box.querySelector('.rating-count__total');
        if (totalBox) totalBox.textContent = '(' + total + ')';

        var sr = box.querySelector('.visually-hidden');
        if (sr) sr.textContent = total + ' reviews';
      }
    }

    pinSummary(reviews);
  }

  /*
    Đồng bộ CẢ khối tóm tắt của widget với danh sách đang hiển thị.

    Khối này Judge.me dựng ở server từ metafield `reviews.rating` /
    `reviews.rating_count` của Shopify, nên nó nói chuyện của một tập review khác
    hẳn tập đang bày ra. Đo 21/08/2026 trên deer-heart-doe-buck:

        điểm trung bình  4.79        <- của 152 review ma
        dòng đếm         152         <- của 152 review ma
        biểu đồ          129/16/5/2/0 (cộng lại đúng 152)
        thực tế hiển thị 18 review, 17 cái 5 sao + 1 cái 4 sao, trung bình 4.94

    Sửa mỗi dòng đếm là khối tự mâu thuẫn với chính nó — trước khi sửa thì cả ba
    cùng sai một kiểu, ít ra còn nhất quán. Nên phải viết lại cả ba cùng lúc.

    PHẢI GHIM, không đặt một lần được: JS của Judge.me vẽ lại khối này sau đó và
    mọi thứ quay về số cũ. Chỉ ghi khi giá trị KHÁC — thiếu điều kiện đó thì mỗi
    lần ghi lại kích hoạt chính observer này, thành vòng lặp vô hạn.

    Tự ngắt sau 30s: quá mốc đó app đã ổn định.
  */
  function pinSummary(reviews) {
    var head = document.querySelector('.jdgm-rev-widg__header');
    if (!head) return;

    var total = reviews.length;
    var sum = 0;
    var rated = 0;
    var freq = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

    reviews.forEach(function (r) {
      if (r.rating >= 1 && r.rating <= 5) {
        freq[r.rating]++;
        sum += r.rating;
        rated++;
      }
    });
    if (!rated) return;

    var avg = sum / rated;
    var countText = 'Based on ' + total + ' review' + (total === 1 ? '' : 's');

    function setText(el, value) {
      if (el && el.textContent.trim() !== value) el.textContent = value;
    }

    function apply() {
      setText(head.querySelector('.jdgm-rev-widg__summary-text'), countText);
      setText(head.querySelector('.cl-jdgm-score'), fmtScore(avg));

      [1, 2, 3, 4, 5].forEach(function (star) {
        var row = head.querySelector('.jdgm-histogram__row[data-rating="' + star + '"]');
        if (!row) return;

        var n = freq[star];
        var pct = rated ? Math.round((n / rated) * 100) : 0;

        if (row.getAttribute('data-frequency') !== String(n)) row.setAttribute('data-frequency', String(n));
        if (row.getAttribute('data-percentage') !== String(pct)) row.setAttribute('data-percentage', String(pct));

        setText(row.querySelector('.jdgm-histogram__frequency'), String(n));

        var bar = row.querySelector('.jdgm-histogram__bar-content');
        if (bar && bar.style.width !== pct + '%') bar.style.width = pct + '%';

        /* Nhãn cho trình đọc màn hình giữ đúng khuôn của app: "85% (129) reviews with 5 star rating". */
        var label = row.querySelector('.jdgm-histogram__star');
        var want = pct + '% (' + n + ') reviews with ' + star + ' star rating';
        if (label && label.getAttribute('aria-label') !== want) label.setAttribute('aria-label', want);
      });
    }

    apply();

    if (!window.MutationObserver) return;
    var mo = new MutationObserver(apply);
    mo.observe(head, { childList: true, characterData: true, subtree: true, attributes: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }

  /*
    Đã hỏi hết cả nhóm mà KHÔNG có review nào.

    Không được để nguyên: metafield `reviews.rating_count` của Shopify vẫn đang
    khai một con số bịa (đo 21/08/2026: sản phẩm Acrylic Table Plaque ghi 13 trong
    khi Judge.me trả 0, và cả danh mục 94 sản phẩm cũng 0). Để nguyên là badge hứa
    13 đánh giá rồi bên dưới trống trơn — đúng cái bug đang phải sửa.

    Ẩn hẳn cụm sao thay vì hiện "0": sản phẩm chưa ai đánh giá thì không nên có
    widget đánh giá. Dòng "No reviews for this product yet — be the first to share
    yours." của judgeme-fix.js vẫn ở lại, và đó mới là thông điệp đúng.

    Dùng display:none chứ không visibility: ở đây KHÔNG có gì thế chỗ, giữ chỗ
    trống là để lại một mảng rỗng khó hiểu dưới tên sản phẩm.
  */
  function markNoReviews() {
    document.documentElement.classList.add('cl-jdgm-no-reviews', 'cl-jdgm-synced');
  }

  function boot() {
    var w = widget();
    if (!w || w.dataset.clTabsBooted) return;

    var productId = w.getAttribute('data-product-id');
    var host = document.querySelector('.jdgm-rev-widg__reviews');
    if (!productId || !host) return;
    /*
      Bình thường phải chờ app dựng xong ít nhất một thẻ review rồi mới chiếm quyền —
      chiếm sớm thì app render đè lên mất.

      Nhưng sản phẩm 0 review mà nằm trong nhóm thì khung này RỖNG VĨNH VIỄN: app tra
      đúng product id, không có review nào, nên không bao giờ dựng thẻ nào cả. Chờ điều
      kiện đó là chờ mãi, và tính năng nhóm không bao giờ khởi động — đúng ca sản phẩm
      deer-heart-doe-buck (0 review thật, metafield ghi 152).

      Có group ID thì cho qua: review sẽ lấy từ sản phẩm anh em, không phụ thuộc app
      có dựng được gì hay không. Sản phẩm không khai nhóm giữ nguyên hành vi cũ.
    */
    /*
      16/10/2026: app đã dựng xong widget mà báo 0 review (data-number-of-reviews="0") thì
      cũng cho qua — khung mới vẫn dựng với "0 Reviews" + nút Write a Review, và khách còn
      tab Store Reviews để xem. Trước đây ca này rơi về giao diện gốc của app, kèm khối ảnh
      của cả store (ảnh ornament dưới sản phẩm áo).
    */
    var emptyWidget = host.closest('.jdgm-rev-widg');
    emptyWidget = emptyWidget && emptyWidget.getAttribute('data-number-of-reviews') === '0';
    if (!host.querySelector('.jdgm-rev') && !siblingIds().length && !emptyWidget) return;

    w.dataset.clTabsBooted = '1';
    if (!buildUI()) return;

    fetchGroup(productId)
      .then(function (nodes) {
        if (!nodes.length) {
          markNoReviews();
          fillItem([]);
          return;
        }
        var reviews = nodes.map(describe).filter(function (r) {
          return !r.rating || r.rating >= MIN_STAR;
        });
        /* Chỉ có review bị loại thì coi như chưa có review nào. */
        if (!reviews.length) {
          markNoReviews();
          fillItem([]);
          return;
        }
        fillItem(reviews);
      })
      .catch(function () {
        /* Gọi API hỏng (mạng, CORS, Judge.me đổi endpoint): gỡ khung mới, widget trở về
           danh sách và phân trang gốc của app. */
        teardown();
        w.dataset.clTabs = 'off';
      });
  }

  boot();

  /* Widget tải lười, thường xuất hiện sau khi script này chạy. */
  var ticks = 0;
  var timer = setInterval(function () {
    boot();
    if (++ticks >= 40 || state) clearInterval(timer);
  }, 400);

  if (window.MutationObserver) {
    var queued = false;
      /* setTimeout chứ không phải requestAnimationFrame — sửa 19/08/2026.
         rAF BỊ TREO ở tab nền, mà khách rất hay mở sản phẩm sang tab nền rồi mới xem.
         Lúc đó setTimeout(30s) ngắt observer vẫn chạy đúng giờ trong khi callback rAF
         chưa hề chạy lần nào → bản vá không bao giờ được áp. setTimeout chỉ bị giãn
         nhịp ở tab nền chứ không treo. 50ms đủ gộp các đợt mutation của Vue. */
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        boot();
      }, 50);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    /* Ngắt sau 30s — 19/08/2026. Trước đây observer này quan sát toàn document
       vĩnh viễn, không bao giờ disconnect. Lấy đúng mốc 30s của judgeme-fix.js:
       widget và khối ảnh đều tải lười, khách đọc mô tả một lúc rồi mới cuộn
       xuống nên 15s là hụt.

       Lưu ý: vòng setInterval bên trên chỉ chạy 40 x 400ms = 16s, nên từ giây 16
       tới 30 chỉ còn observer này đỡ. Nếu sau này Judge.me bật lazy-load cho widget
       review (jdgmSettings hiện KHÔNG bật) thì phải nới cả hai mốc, không thì widget
       mount muộn sẽ không có ai boot thanh tab. */
    setTimeout(function () {
      observer.disconnect();
    }, 30000);
  }
})();
